import  { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import axios from 'axios';
import FAQAccordion from '../components/FAQAccordian';
import FeaturedSection from '../components/FeaturedSection';
import {  toast } from 'react-hot-toast';




const Home = () => {
  // State for crypto prices
  const [cryptoPrices, setCryptoPrices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Top cryptos to fetch (IDs from CoinGecko)
  const topCryptos = [
    { id: 'bitcoin', symbol: 'BTC', name: 'Bitcoin' },
    { id: 'ethereum', symbol: 'ETH', name: 'Ethereum' },
    { id: 'binancecoin', symbol: 'BNB', name: 'BNB' },
    { id: 'solana', symbol: 'SOL', name: 'Solana' },
    { id: 'cardano', symbol: 'ADA', name: 'Cardano' },
    { id: 'ripple', symbol: 'XRP', name: 'XRP' },
    { id: 'dogecoin', symbol: 'DOGE', name: 'Dogecoin' },
  ];

  // Fetch prices
  const fetchPrices = async () => {
    try {
      const ids = topCryptos.map(crypto => crypto.id).join(',');
      const response = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=${ids}&vs_currencies=usd&include_24hr_change=true`
      );
      const prices = topCryptos.map(crypto => ({
        ...crypto,
        price: response.data[crypto.id].usd,
        change: response.data[crypto.id].usd_24h_change,
      }));
      setCryptoPrices(prices);
    } catch (error) {
      console.error('Error fetching prices:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices(); // Initial fetch
    const interval = setInterval(fetchPrices, 30000); // Refresh every 30s
    return () => clearInterval(interval); // Cleanup
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Testimonials data
  const testimonials = [
    {
      name: 'Alice Johnson',
      comment: 'SwiftVault has been a game-changer for storing my Bitcoin and Ethereum securely. The 2FA and email alerts make me feel totally protected—no more worries about hacks!',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
      rating: 5,
    },
    {
      name: 'Bob Ramirez',
      comment: 'I love using this platform for my daily crypto trades. The real-time notifications keep me ahead of the market, and the KYC process was super quick. Future trading here for sure!',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
      rating: 5,
    },
    {
      name: 'Carol Lee',
      comment: 'Storing my altcoins like SOL and ADA has never been easier. The dashboard is intuitive, and admin funding options mean I can scale my portfolio effortlessly. Highly recommend!',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
      rating: 5,
    },
    {
      name: 'David Kim',
      comment: 'As a beginner, SwiftVault made trading my first Dogecoin feel safe and fun. The seed phrase management and transaction history are top-notch—planning to go all-in for long-term holds.',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
      rating: 5,
    },
  ];

 




  // Star component
  const Stars = ({ rating }) => (
    <div className="flex items-center">
      {[...Array(5)].map((_, i) => (
        <svg key={i} className="w-5 h-5 text-success fill-current" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );


  const partners = [
  { name: 'Bitcoin', logo: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png', id: 'bitcoin' },
  { name: 'Ethereum', logo: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png', id: 'ethereum' },
  { name: 'Binance Coin', logo: 'https://assets.coingecko.com/coins/images/825/large/binance-coin-logo.png', id: 'binancecoin' },
  { name: 'Solana', logo: 'https://assets.coingecko.com/coins/images/4128/large/solana.png', id: 'solana' },
  { name: 'Cardano', logo: 'https://assets.coingecko.com/coins/images/975/large/cardano.png', id: 'cardano' },
  { name: 'Polkadot', logo: 'https://assets.coingecko.com/coins/images/12171/large/polkadot.png', id: 'polkadot' },
];

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      {/* Hero Section */}
    <section className="pt-20 pb-16 bg-gradient-to-b from-purple-900 to-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center gap-8 md:gap-12">
        {/* Left Side: Hero Content */}
        <div className="md:w-1/2 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            Securely Manage Your Crypto
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed max-w-lg mx-auto md:mx-0">
            Join SwiftVault to trade, store, and manage your digital assets with ease and top-tier security.
          </p>
          <Link
            to="/register"
            className="bg-purple-700 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-purple-800 transition-colors duration-300 shadow-md"
          >
            Start Now
          </Link>
        </div>
        {/* Right Side: Dashboard Preview */}
        <div className="md:w-1/2 flex justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md space-y-6 border border-gray-200">
            {/* Welcome Message */}
            <h2 className="text-2xl font-semibold text-purple-900 mb-2">Welcome, User!</h2>
            {/* Wallet Balance Card */}
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm space-y-4">
              <div>
                <p className="text-gray-600 text-sm">Wallet Balance</p>
                <p className="text-2xl font-bold text-green-600 mt-1">$4,085.38</p>
              </div>
              {/* Action Buttons */}
              <div className="flex justify-between space-x-2">
                <button 
                  className="bg-purple-700 text-white p-3 rounded-lg flex flex-col items-center justify-center space-y-1 hover:bg-purple-800 transition-colors duration-300 flex-1"
                  aria-label="Send Crypto"
                >
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                  </svg>
                  <span className="text-xs font-medium">Withdraw</span>
                </button>
                <button 
                  className="bg-purple-700 text-white p-3 rounded-lg flex flex-col items-center justify-center space-y-1 hover:bg-purple-800 transition-colors duration-300 flex-1"
                  aria-label="Swap Crypto"
                >
                  
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e2dfdf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-blend-icon lucide-blend"><circle cx="9" cy="9" r="7"/><circle cx="15" cy="15" r="7"/></svg>

                  <span className="text-xs font-medium">Swap</span>
                </button>
                <button 
                  className="bg-purple-700 text-white p-3 rounded-lg flex flex-col items-center justify-center space-y-1 hover:bg-purple-800 transition-colors duration-300 flex-1"
                  aria-label="Fund Wallet"
                >
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08 .402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-xs font-medium">Deposit</span>
                </button>
                <button 
                  className="bg-purple-700 text-white p-3 rounded-lg flex flex-col items-center justify-center space-y-1 hover:bg-purple-800 transition-colors duration-300 flex-1"
                  aria-label="Buy Crypto"
                >
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span className="text-xs font-medium">Buy</span>
                </button>
              </div>
            </div>
            {/* Status Cards */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm">
                <p className="text-gray-600 text-sm">KYC Status</p>
                <p className="text-red-500 font-medium mt-1">Pending</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm">
                <p className="text-gray-600 text-sm">Account Status</p>
                <p className="text-green-600 font-medium mt-1">Active</p>
              </div>
            </div>
            {/* Your Crypto Section */}
            <div className="bg-gradient-to-br from-purple-700 to-purple-500 rounded-xl p-4 text-white shadow-md">
              <p className="text-lg font-bold">Your Crypto</p>
              <p className="text-sm mt-1 font-medium">
                Total Value: <span className="text-xl font-bold">$4,085.38</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Crypto Prices Widget Section */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-center text-primary mb-6">Live Crypto Prices</h2>
          {loading ? (
            <div className="text-center text-secondary">Loading prices...</div>
          ) : (
            <div className="overflow-hidden">
              <div className="flex animate-marquee whitespace-nowrap">
                {cryptoPrices.map((crypto) => (
                  <div key={crypto.id} className="flex items-center space-x-4 px-6 py-3 mx-2 bg-white rounded-lg shadow-sm border border-gray-200 min-w-max">
                    <span className="text-sm font-semibold text-secondary">{crypto.symbol}</span>
                    <span className="text-lg font-bold text-primary">${crypto.price.toLocaleString()}</span>
                    <span className={`text-sm font-medium ${
                      crypto.change >= 0 ? 'text-success' : 'text-error'
                    }`}>
                      {crypto.change >= 0 ? '+' : ''}{crypto.change.toFixed(2)}%
                    </span>
                  </div>
                ))}
                {/* Duplicate for seamless loop */}
                {cryptoPrices.map((crypto) => (
                  <div key={`dup-${crypto.id}`} className="flex items-center space-x-4 px-6 py-3 mx-2 bg-white rounded-lg shadow-sm border border-gray-200 min-w-max">
                    <span className="text-sm font-semibold text-secondary">{crypto.symbol}</span>
                    <span className="text-lg font-bold text-primary">${crypto.price.toLocaleString()}</span>
                    <span className={`text-sm font-medium ${
                      crypto.change >= 0 ? 'text-success' : 'text-error'
                    }`}>
                      {crypto.change >= 0 ? '+' : ''}{crypto.change.toFixed(2)}%
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
      <FeaturedSection />

      {/* Redesigned Features Section (2025 Vibes) */}
<section className="py-16 bg-gradient-to-b from-white to-gray-50">
  <div className="container mx-auto px-4">
    <h2 className="text-4xl md:text-5xl font-bold text-center text-primary mb-4 tracking-tight">
      Why Choose SwiftVault?
    </h2>
    <p className="text-xl text-center text-secondary mb-16 max-w-2xl mx-auto">
      Unlock the future of crypto with secure, seamless tools built for traders and holders alike.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {/* Feature 1: Secure Wallet */}
      <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 animate-fadeInUp" style={{ animationDelay: '0s' }}>
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-purple-400 rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-primary mb-3 group-hover:text-purple-700 transition-colors">Secure Wallet</h3>
        <p className="text-secondary leading-relaxed">
          Store your assets with bank-grade encryption, multi-sig wallets, and 2FA—peace of mind for long-term holds.
        </p>
      </div>

      {/* Feature 2: Easy KYC */}
      <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
        <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-400 rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-primary mb-3 group-hover:text-purple-700 transition-colors">Easy KYC</h3>
        <p className="text-secondary leading-relaxed">
          Verify in minutes with AI-powered doc scans—fast-track your trades without the hassle.
        </p>
      </div>

      {/* Feature 3: Real-Time Updates */}
      <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-primary mb-3 group-hover:text-purple-700 transition-colors">Real-Time Updates</h3>
        <p className="text-secondary leading-relaxed">
          Get instant push notifications and emails on every transaction—stay ahead of market moves.
        </p>
      </div>

      {/* New Feature 4: Multi-Chain Support */}
      <div className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
        <div className="w-16 h-16 bg-gradient-to-br from-info to-blue-400 rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-primary mb-3 group-hover:text-purple-700 transition-colors">Multi-Chain Support</h3>
        <p className="text-secondary leading-relaxed">
          Seamlessly swap across ETH, SOL, and more—bridge assets effortlessly for smarter trading.
        </p>
      </div>
    </div>
  </div>
</section>


      
      {/* New Testimonials Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">What Our Users Say</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md border border-gray-200 animate-fadeInUp"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full mr-3 object-cover"
                  />
                  <div>
                    <h4 className="font-semibold text-secondary">{testimonial.name}</h4>
                    <Stars rating={testimonial.rating} />
                  </div>
                </div>
                <blockquote className="text-secondary italic mb-4">
                  &ldquo;{testimonial.comment}&rdquo;
                </blockquote>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FAQAccordion />
{/* Partners Logos Row - Test Version (Full Visibility) */}
<section className="py-12 bg-gray-50 "> {/* Temp red border to spot the section */}
  <div className="container mx-auto px-4">
    <h2 className="text-2xl font-bold text-center text-primary mb-8">Supported By Leading Crypto Networks</h2>
    <div className="overflow-hidden">
      <div className="flex animate-marquee-slow whitespace-nowrap"> {/* Slower animation class */}
        {partners.map((partner) => (
          <div key={partner.id} className="flex items-center justify-center px-8 py-4 mx-2 min-w-max"> {/* Smaller padding for more space */}
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-16 w-auto bg-white p-2 rounded shadow-md" // Bigger height, white bg/padding for visibility, no opacity/grayscale
              onLoad={() => console.log(`Loaded: ${partner.name}`)} // Temp log to confirm loads
              onError={(e) => console.error(`Failed: ${partner.name}`, e)} // Temp error log
            />
          </div>
        ))}
        {/* Duplicate for seamless loop */}
        {partners.map((partner) => (
          <div key={`dup-${partner.id}`} className="flex items-center justify-center px-8 py-4 mx-2 min-w-max">
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-16 w-auto bg-white p-2 rounded shadow-md"
              onLoad={() => console.log(`Loaded: ${partner.name}`)}
              onError={(e) => console.error(`Failed: ${partner.name}`, e)}
            />
          </div>
        ))}
        {partners.map((partner) => (
          <div key={`dup-${partner.id}`} className="flex items-center justify-center px-8 py-4 mx-2 min-w-max">
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-16 w-auto bg-white p-2 rounded shadow-md"
              onLoad={() => console.log(`Loaded: ${partner.name}`)}
              onError={(e) => console.error(`Failed: ${partner.name}`, e)}
            />
          </div>
        ))}
        {partners.map((partner) => (
          <div key={`dup-${partner.id}`} className="flex items-center justify-center px-8 py-4 mx-2 min-w-max">
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-16 w-auto bg-white p-2 rounded shadow-md"
              onLoad={() => console.log(`Loaded: ${partner.name}`)}
              onError={(e) => console.error(`Failed: ${partner.name}`, e)}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
</section>
{/* Download App Section */}
<section className="py-20 bg-gradient-to-b from-gray-50 to-white">
  <div className="container mx-auto px-4 text-center">
    <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
      Get the SwiftVault App
    </h2>
    <p className="text-xl text-secondary mb-12 max-w-2xl mx-auto">
      Trade, store, and manage your crypto on the go with our native mobile app – coming soon to your region!
    </p>

    <div className="flex flex-col sm:flex-row gap-8 items-center justify-center">
      <button
        onClick={() =>
          toast.error('Sorry, the SwiftVault app is not available in your region yet.', {
            duration: 5000,
            icon: '🚫',
          })
        }
        className="transform hover:scale-105 transition-transform duration-300"
      >
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="Download on the App Store"
          className="h-14 md:h-16"
        />
      </button>

      {/* Google Play Button */}
      <button
        onClick={() =>
          toast.error('Sorry, the SwiftVault app is not available in your region yet.', {
            duration: 5000,
            icon: '🚫',
          })
        }
        className="transform hover:scale-105 transition-transform duration-300"
      >
        <img
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
          alt="Get it on Google Play"
          className="h-14 md:h-16"
        />
      </button>
    </div>

    <p className="mt-10 text-sm text-gray-500">
      Stay tuned - we're expanding to more countries every month!
    </p>
  </div>
</section>

      {/* Redesigned Footer (Crypto Pro Style) */}
<footer className="bg-gradient-to-r from-primary to-purple-900 text-white relative overflow-hidden">
  {/* Subtle wave divider (optional crypto flair) */}
  <div className="absolute inset-x-0 bottom-0 h-16 bg-white opacity-5 -translate-y-1/2"></div>
  
  <div className="container mx-auto px-4 py-16">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
      {/* Column 1: Company */}
      <div>
        <h3 className="text-xl font-bold mb-4">
          {/* Text – kept bold and premium */}
     <text
  x="115"
  y="82"
  fontFamily="Exo 2, Rajdhani, system-ui, sans-serif"
  fontWeight="900"
  fontSize="56"
  fill="#e2e8f0"
  letterSpacing="2"
  style={{ textShadow: '0 2px 4px rgba(0,0,0,0.6)' }}
>
  SwiftVault
</text>
        </h3>
        <p className="text-white/70 mb-4 leading-relaxed">
          Securely store, trade, and manage your crypto assets with cutting-edge tools designed for the future.
        </p>
        <div className="flex space-x-4">
          {/* Social Icons (SVG stubs) */}
           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-comment-textnodes */}
          <a href="" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
          </a>
           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-comment-textnodes */}
          <a href="" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
          </a>
           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/jsx-no-comment-textnodes */}
          <a href="" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm-9 23.7c-5.5 0-10-4.5-10-10S5.5 3.7 11 3.7s10 4.5 10 10-4.5 10-10 10zm0-18.4c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm9.5 15.3c0 .8-.7 1.5-1.5 1.5h-13c-.8 0-1.5-.7-1.5-1.5v-1.3c0-.8.7-1.5 1.5-1.5h13c.8 0 1.5.7 1.5 1.5v1.3z"/></svg>
          </a>
        </div>
      </div>

      {/* Column 2: Products */}
      <div>
        <h4 className="text-lg font-semibold mb-4">Products</h4>
        <ul className="space-y-2 text-white/70">
          <li><Link to="#" className="hover:text-white transition-colors">Wallet</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Trading</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Staking</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">NFT Marketplace</Link></li>
        </ul>
      </div>

      {/* Column 3: Resources */}
      <div>
        <h4 className="text-lg font-semibold mb-4">Resources</h4>
        <ul className="space-y-2 text-white/70">
          <li><Link to="#" className="hover:text-white transition-colors">Blog</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Help Center</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">API Docs</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Community</Link></li>
        </ul>
      </div>

      {/* Column 4: Legal */}
      <div>
        <h4 className="text-lg font-semibold mb-4">Legal</h4>
        <ul className="space-y-2 text-white/70">
          <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Terms of Service</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Cookie Policy</Link></li>
          <li><Link to="#" className="hover:text-white transition-colors">Disclaimer</Link></li>
        </ul>
      </div>
    </div>

    {/* Newsletter Signup */}
    <div className="border-t border-white/10 pt-8 mb-8">
      <h4 className="text-lg font-semibold mb-4 text-center md:text-left">Stay Updated</h4>
      <div className="flex flex-col sm:flex-row gap-4">
        <input
          type="email"
          placeholder="Enter your email"
          className="flex-1 px-4 py-3 rounded-md bg-white/10 text-white placeholder-white/50 border border-white/20 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <button className="px-6 py-3 bg-info text-white rounded-md font-semibold hover:bg-blue-500 transition-colors">
          Subscribe
        </button>
      </div>
    </div>

    {/* Bottom Bar */}
    <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center text-white/50">
      <p>&copy; 2025 SwiftVault. All rights reserved.</p>
      <div className="space-x-4 mt-2 sm:mt-0">
        <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
        <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
        <Link to="/support" className="hover:text-white transition-colors">Support</Link>
      </div>
    </div>
  </div>
</footer>
{/* Floating Telegram Support Button */}
<a
  href="https://t.me/Swiftcoinvault" /* ← CHANGE THIS TO YOUR REAL TELEGRAM USERNAME */
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 z-50 group"
  aria-label="Chat with support on Telegram"
>
  <div className="relative">
    {/* Pulse ring animation */}
    <div className="absolute inset-0 rounded-full bg-[#0088cc] opacity-75 animate-ping"></div>
    
    {/* Main button */}
    <div className="relative bg-[#0088cc] p-4 rounded-full shadow-2xl hover:shadow-[#0088cc]/50 transform hover:scale-110 transition-all duration-300 border-4 border-white">
      {/* Telegram Icon (official SVG) */}
      <svg
        className="w-8 h-8 text-white"
        viewBox="0 0 240 240"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M120 240c66.274 0 120-53.726 120-120S186.274 0 120 0 0 53.726 0 120s53.726 120 120 120z"/>
        <path
          d="M53.033 126.324c39.71-17.053 66.36-28.323 79.686-33.724 38.234-15.446 46.234-18.07 51.74-18.3 1.22-.05 3.95.28 5.7 1.71.99.81 1.27 1.92.7 2.71-.57.79-1.42 1.79-2.54 2.95-7.09 7.38-35.85 36.21-50.46 51.51-2.12 2.22-3.54 3.71-4.84 3.41-1.3-.3-1.92-1.34-2.71-2.59-1.12-1.77-6.98-10.62-10.19-15.09-3.21-4.47-6.44-8.14-9.48-11.94-3.04-3.8-1.07-5.9.65-6.98 1.72-1.08 30.47-28.08 31.03-30.39.07-.29.13-.54.18-.78.05-.24.09-.47.12-.68.03-.21.05-.4.05-.57 0-.87-.33-1.18-.88-1.18-.55 0-1.39.35-3.12 1.76-1.73 1.41-16.66 10.64-24.91 15.56-8.25 4.92-17.67 10.38-19.75 10.94-2.08.56-4.42.91-6.76.36-2.34-.55-4.44-1.41-6.38-2.47-2.13-1.16-3.95-2.48-5.73-3.85-1.6-1.23-3.29-2.58-2.28-4.36z"
          fill="white"
        />
      </svg>

      {/* Optional "Live Chat" tooltip */}
      <span className="absolute -top-12 right-0 bg-black/90 text-white text-xs px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        Live Support 24/7
      </span>
    </div>
  </div>
</a>
    </div>
  );
};

// Custom marquee animation (add to a CSS file or inline)
const marqueeStyle = `
@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-marquee {
  animation: marquee 20s linear infinite;
}
`;

// Inject the animation (or add to public/index.html <style> tag)
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = marqueeStyle;
document.head.appendChild(styleSheet);



export default Home;